/*
    Description: video class for video library page
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/
// video class
// import utility
import Utility from "../inc/utility";

// extend utility class
class Videos extends Utility{

    // constructor
    constructor({
        loadMoreLinkClass = null,
        videoErrorClass = null,
        errorClass = null,
        loadClass = null,
        nonceClass = null,
        ulClass = null,
    } = {}){

        // extend class
        super();

        // get ul DOM 
        this.ul = document.querySelector(`.${ulClass}`);

        // get link DOM
        this.link = document.querySelector(`.${loadMoreLinkClass}`);

        // get nonce DOM
        this.nonce = document.querySelector(`.${nonceClass}`);

        // video error class 
        this.videoError = videoErrorClass;

        // error class 
        this.error = errorClass;

        // ajax loading
        this.loading = loadClass;

        // ajax progress status
        this.progress = false;

        // run all events
        this.events();

    }

    // all events
    events(){

        // end case for DOM elements
        if(!this.link || !this.ul || !this.nonce) return;

        // add link event listner
        this.link.addEventListener("click", this.load.bind(this));

    }

    // process load more
    load(e){

        // prevemt default
        e.preventDefault();

        // end case - make sure we are not in
        // the middle of an ajx call already
        if(this.progress === true) return;

        // init const
        const target = e.target,

        // get current port
        port = target.dataset.port,

        // get next page token
        token = target.dataset.token,

        // get nonce value
        nonce = this.nonce.value,

        // set self to this
        self = this, 

        // init form data
        form = new FormData();

        // add loading gif
        target.classList.add(self.loading);

        // progress started
        self.progress = true;

        // update form data
        if(form && port) form.append('portal', port);
        if(form && token) form.append("token", token);
        if(form && nonce) form.append('nonce', nonce);

        // ajax call
        self.ajax({
            
            // url
            action:"load-more-videos",
            
            // send data
            data:form,
            
        // promise results 
        }).then((results) => {

            // ERROR: check error first
            if(results.error){

                // get any previous DOM error msg
                const existingError = self.ul.parentNode.querySelector(`.${self.videoError}`),
                
                // create error wrapper DOM
                errorWrapper = document.createElement("p");

                // add class to created DOM element
                errorWrapper.classList.add(self.error, self.videoError);

                // add error msg to DOM element
                errorWrapper.textContent = results.error;

                // remove existing msg
                if(existingError) existingError.remove();

                // append first child to ul DOM element
                target.parentNode.parentNode.insertBefore(errorWrapper, target.parentNode);

            // no error
            }else{
                
                // check for token
                target.dataset.token = (results.token && (results.token != 0)) ? results.token : false;

                // remove link if we need too
                if(target.dataset.token == "false") self.link.remove();

            }
            
            // SUCCESS
            if(results.success){

                // double check ul DOM 
                if(self.ul){

                    // create tmp DOM element
                    const tmpDOM = document.createElement("div");

                    // add string HTML to 
                    tmpDOM.innerHTML = results.success;

                    // LOOP: thru child nodes
                    while(tmpDOM.firstChild){

                        // append first child to ul DOM element
                        self.ul.appendChild(tmpDOM.firstChild);

                    }

                    // delete 
                    tmpDOM.remove();

                }

            }

            // remove loading gif
            target.classList.remove(self.loading);     

            // reset progress
            self.progress = false;

        // catch error
        }).catch((err) => {
            
            // remove loading gif
            target.classList.remove(self.loading);

            // reset progress
            self.progress = false;

            // display error
            console.log(err);

        });

    }

}

// export module
export default Videos;